import type { ChangeEvent } from 'react';

import BpkHorizontalNav, {
  BpkHorizontalNavItem,
} from '@skyscanner/backpack-web/bpk-component-horizontal-nav';
import { BpkSpinner } from '@skyscanner/backpack-web/bpk-component-spinner';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { GalleryNavigationClickEventHandler } from '../types';
import type { NavigationItemType } from '@hotels-hotel-detail/utils/gallery-navigation';
import type { MiniEventTracker } from '@shared/types/frontend/mini-event-tracker';

import STYLES from './GalleryNavigation.module.scss';

import { NavigationItems } from '@hotels-hotel-detail/utils/gallery-navigation';
import { buildAdditionalInfoHotelMediaGalleryClicked } from '@hotels-hotel-detail/utils/mini-events/hotels-action';
import { FormattedMessage } from '@shared/ui/components/i18n';
import { withMiniEventTracker } from '@shared/ui/contexts/mini-events';
import {
  ACTION_TYPE,
  HOTEL_MEDIA_TYPE,
} from '@shared/utils-frontend/mini-events/constants';

const cls = cssModules(STYLES);
type Props = {
  isLoading?: boolean;
  selectedNav: NavigationItemType;
  hotelImageGalleryLength: number;
  travellerImageGalleryLength: number;
  onNavClick: GalleryNavigationClickEventHandler;
  miniEventTracker: MiniEventTracker;
};

const GalleryNavigation = ({
  hotelImageGalleryLength,
  isLoading,
  miniEventTracker,
  onNavClick,
  selectedNav,
  travellerImageGalleryLength,
}: Props) => {
  const navItem = [
    {
      id: NavigationItems.hotel,
      content: (
        <FormattedMessage
          label="HotelImageGallery_nav_hotelPhotos"
          data={{
            number: isLoading ? (
              <BpkSpinner
                className={cls(
                  selectedNav === NavigationItems.hotel
                    ? 'GalleryNavigation__spinner--selected'
                    : 'GalleryNavigation__spinner--normal',
                )}
              />
            ) : (
              hotelImageGalleryLength
            ),
          }}
        />
      ),
    },
    {
      id: NavigationItems.traveller,
      content: (
        <FormattedMessage
          label="HotelImageGallery_nav_travellerPhotos"
          data={{
            number: isLoading ? (
              <BpkSpinner
                className={cls(
                  selectedNav === NavigationItems.traveller
                    ? 'Navigation__spinner--selected'
                    : 'Navigation__spinner--normal',
                )}
              />
            ) : (
              travellerImageGalleryLength
            ),
          }}
        />
      ),
    },
  ];

  const onClick = (e: ChangeEvent<HTMLInputElement>) => {
    onNavClick(e.target.name as NavigationItemType);
    if (e.target.name === NavigationItems.traveller) {
      miniEventTracker.trackHotelsAction(
        ACTION_TYPE.HOTEL_MEDIA_GALLERY_CLICKED,
        buildAdditionalInfoHotelMediaGalleryClicked({
          hotelMediaType: HOTEL_MEDIA_TYPE.TRAVELLER_PHOTOS,
        }),
      );
    }
  };

  return (
    <BpkHorizontalNav>
      {navItem.map((nav) => (
        <BpkHorizontalNavItem
          key={nav.id}
          name={nav.id}
          selected={selectedNav === nav.id}
          onClick={onClick}
        >
          {nav.content}
        </BpkHorizontalNavItem>
      ))}
    </BpkHorizontalNav>
  );
};

export default withMiniEventTracker(GalleryNavigation);
